<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M2.2 4.2A2 2 0 1 1 5 6v5.3h6.4V6a2 2 0 1 1 1.4 0v5.3H16l2-.1q.7 0 .8-.3l.3-.8V6a2 2 0 1 1 1.5 0v4.3q-.1 1-.7 1.6t-1.7.8h-5.4V18a2 2 0 1 1-1.4 0v-5.3H4.9V18a2 2 0 1 1-1.4 0V6a2 2 0 0 1-1.3-1.8"
    />
    <path
      d="M12 2a2.2 2.2 0 0 1 1 4.2V11h5.2l.3-.3.3-.6v-4a2.2 2.2 0 1 1 2 0v2l-.1 2.3q0 1-.8 1.7-.7.7-1.7.8H13v5a2.2 2.2 0 1 1-2 0v-5H5.2v5a2.2 2.2 0 1 1-2 0V6.1a2.2 2.2 0 1 1 2 0V11H11V6.2A2.2 2.2 0 0 1 12 2M2.5 4.2a2 2 0 0 0 1 1.6h.2v12.4h-.1a1.7 1.7 0 1 0 1.2 0h-.1v-5.7h6.8v5.7h-.1a1.7 1.7 0 1 0 1.2 0h-.1v-5.7H18l.2-.1q.8-.2 1.3-.6.5-.7.6-1.5V5.8h.2a1.7 1.7 0 1 0-1.2 0h.1v4.3q-.1.7-.4 1-.2.3-1 .3l-2 .1h-3.4V5.8h.1a1.7 1.7 0 1 0-1.2 0h.1v5.7H4.7V5.8h.1a1.7 1.7 0 1 0-2.3-1.6"
    />
  </svg>
</template>
